
import React, { Component } from 'react';

const colorSet = [
  '#98ccfd', '#2ecc71', '#f1c40f', '#e74c3c', '#98ccfd'
]

class ProgressStat extends Component { 
  constructor(props) {
    super(props);
  }

  render() {
    if(this.props.stats.number === 0) return(<div></div>);
    

    let percentage = (parseFloat(this.props.stats.number) / parseFloat(this.props.stats.max)) * 100;
    if(percentage > 100) percentage = 100;

    let color = '#98ccfd';
    let icon = this.props.stats.markers[0];
    
    if(percentage > 26 && percentage < 50) {
      color = colorSet[1];
      icon = this.props.stats.markers[1];
    } else if(percentage > 50 && percentage < 75) {
      color = colorSet[2];
      icon = this.props.stats.markers[2];
    } else if(percentage > 75 && percentage < 100) {
      color = colorSet[3];
      icon = this.props.stats.markers[3];
    } else if(percentage > 99) {
      icon = this.props.stats.markers[4];
    }

    return(
      <div className={'stat-' + this.props.index + ' flex flex-wrap pt4 pb4'}>
        <div className="progress-number flex mb1 w-100">
          <div className="pusher w-30">
          </div>
          <div className="w-70 tl">
            <div
              className="raw-number relative flex" 
              style= {{
                marginLeft: ('' + percentage + '%')
              }}>
              <span className="relative transformX--100 b">
                {Number(this.props.stats.number).toLocaleString()}
                <span className="absolute pl1"> {this.props.stats.unit}</span>
              </span>
            </div>
          </div>
        </div>

        <div className="w-30 flex items-center">
          <img src={icon} height="24" width="24" /> <span className="ml2">{this.props.stats.verb}</span>
        </div>
        <div className="progress relative flex w-70">
          <div 
            className="activeStat"
            style={{
              width: ('' + percentage + '%'), 
              backgroundColor: color}}
            >
          </div>
        </div>
        <div className="line-markers flex w-100">
          <div className="w-30"></div>
          <div className="flex w-70">
            <div className="fifth relative w-25 h1">
              <div className="icon absolute left-0 top-100 transformX--50">
                <img src={this.props.stats.markers[0]} height="24" width="24" />
                <small className="number-segment db">
                  0
                </small>
              </div>
            </div>
            <div className="fifth relative w-25 h1">
              <div className="icon absolute left-0 top-100 transformX--50">
                <img src={this.props.stats.markers[1]} height="24" width="24" />
                <br/>
                <small className="number-segment db">
                  {Math.round((this.props.stats.max / 1000) * 0.25)} k
                </small>
              </div>
            </div>
            <div className="fifth relative w-25 h1">
              <div className="icon absolute left-0 top-100 transformX--50">
                <img src={this.props.stats.markers[2]} height="24" width="24" />
                <br/>
                <small className="number-segment db">
                  {Math.round((this.props.stats.max / 1000) * 0.5)} k
                </small>
              </div>
            </div>
            <div className="fifth fifth-last relative w-25 h1">
              <div className="icon absolute left-0 top-100 transformX--50">
                <img src={this.props.stats.markers[3]} height="24" width="24" />
                <br/>
                <small className="number-segment db">
                  {Math.round((this.props.stats.max / 1000) * 0.75)} k
                </small>
              </div>
              <div className="icon absolute right-0 top-100 transformX-50">
                <img src={this.props.stats.markers[4]} height="24" width="24" />
                <br/>
                <small className="number-segment db">
                  {Math.round((this.props.stats.max / 1000) * 1)} k
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProgressStat;


// WEBPACK FOOTER //
// ./src/components/ProgressStat.js